export class SpecificsLabel {
  labelName;
  labelValue;

  getFormattedLabel(): string {
    return this.labelName + ': ' + this.labelValue;
  }

}
